import type { RadioOption } from "./types";

export const MAX_INSTRUCTIONS_LENGTH = 1000;
export const MAX_URL_LENGTH = 2000;

// The only to-dos that take a supporting URL. Matched on id, not title: titles are CMS-editable.
export const SUPPORTING_URL_TODO_IDS: string[] = [
  "d00e3eff-5549-41fb-b87d-9a29c7587754", // Supplemental Form 1
  "ebd00197-f50c-4f19-b242-6bd4a1551c13", // Supplemental Form 2
  "a266a1a1-8b36-4a92-90cd-e4008b40b4fb", // Supplemental Form 3
  "04605202-ef20-4ffb-8b8e-a47c71b7acc5", // Supplemental Form 4
];

export const RANKING_OPTIONS: RadioOption[] = [
  {
    label: "Normal",
    value: 0,
  },
  {
    label: "High",
    value: 1,
  },
  {
    label: "Normal",
    value: 2,
  },
];

export const PLACEMENT_OPTIONS: RadioOption[] = [
  {
    label: "Application",
    value: "Application",
  },
  {
    label: "Onboarding",
    value: "Onboarding",
  },
];
